import type { FC } from "react";
import { useState } from "react";
import { useSearchParams } from "react-router";
import { useCommunicationInsightsByMoment } from "../hooks/use-communication-insights-by-moment";
import { InsightsAvailableButton } from "./insights-available-button";
import { InsightsSidePanel } from "./insights-side-panel";

/**
 * Renders the "Insights available" button only when this Communication actually
 * has insights, sharing the loaded data with the side panel it opens.
 */
export const MomentInsights: FC<{ momentId: string }> = ({ momentId }) => {
  const [open, setOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const insights = useCommunicationInsightsByMoment(momentId);
  const requestedByUrl = searchParams.get("insights") === "true";

  const close = (): void => {
    setOpen(false);

    if (requestedByUrl) {
      const nextSearchParams = new URLSearchParams(searchParams);
      nextSearchParams.delete("insights");
      setSearchParams(nextSearchParams, { replace: true });
    }
  };

  if ((insights.data ?? []).length === 0) return null;

  return (
    <>
      <InsightsAvailableButton onClick={() => setOpen(true)} />
      <InsightsSidePanel open={open || requestedByUrl} onClose={close} insights={insights} />
    </>
  );
};
